import usdcLogo from "../../../../../public/apm/usdc-logo.svg";
import usdtLogo from "../../../../../public/apm/usdt-logo.svg";
import ethLogo from "../../../../../public/apm/eth-logo.svg";
var paymentMethodIconMap = [
    {
        icon: usdcLogo,
        name: "USDC",
    },
    {
        icon: usdtLogo,
        name: "USDT",
    },
    {
        icon: ethLogo,
        name: "ETH",
    },
    {
        icon: ethLogo,
        name: "SepoliaTestnet",
    },
];
export var getPaymentMaymentMethodIcon = function (paymentMethod) {
    var _a;
    return ((_a = paymentMethodIconMap.find(function (item) { return item.name === paymentMethod; })) === null || _a === void 0 ? void 0 : _a.icon) || usdcLogo;
};
